"use client";

import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";
import {
  NavbarContent,
  NavbarItem,
  Button,
  DropdownItem,
  DropdownTrigger,
  Dropdown,
  DropdownMenu,
  Navbar,
  NavbarBrand,
} from "@heroui/react";
import type { LoginUser } from "@/app/api/auth/[...nextauth]/options";
import { signOut } from "next-auth/react";
import { IconChevronDown } from "@tabler/icons-react";


export default function Header({ user }: { user: LoginUser | undefined }) {
  const pathname = usePathname();

  const icons = {
    chevron: <IconChevronDown size={16} />,
  };

  return (
    <Navbar maxWidth="full" isBordered>
      <div className="w-full px-4 py-4 flex items-center">
        <NavbarBrand>
          <Link href="/" className="flex gap-2 items-center">
            <Image src="/image/logo.png" alt="Keyman Pro" width={25} height={25} />
            <span className="text-red-600 font-bold text-sm mt-1">KEYMAN-PRO</span>
          </Link>
        </NavbarBrand>

        <NavbarContent justify="end">
          {user && (
            <Dropdown>
              <NavbarItem>
                <DropdownTrigger>
                  <Button
                    disableRipple
                    className="p-0 bg-transparent data-[hover=true]:bg-transparent"
                    endContent={icons.chevron}
                    radius="sm"
                    variant="light"
                  >
                    {user.name}
                  </Button>
                </DropdownTrigger>
              </NavbarItem>
              <DropdownMenu>
                <DropdownItem onClick={() => signOut()} key={"logout"}>ログアウト</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          )}
        </NavbarContent>
      </div>
    </Navbar>
  );
}
